import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import searchTranslations from 'public/locales/en/search.json';
import { getTranslator } from '../../i18n/getTranslator';
import {
    DropdownWrapper,
    RightWrapper,
    LeftWrapper
} from '../../../search/common/Dropdown.styles';
import {
    ForSalePriceMinSelectOptions,
    ForSalePriceMaxSelectOptions
} from '../../../search/common/SelectPriceOptions';
import {
    updateFilter,
    minPriceSelector,
    maxPriceSelector
} from '../../../reducers/filters';
import { FilterWrapper } from './SearchInitiationMobile.styles';
import { StyledDropdownWithLabel } from './SearchInitiationMobile.styles';

const t = getTranslator(searchTranslations);
export const SelectPriceForSale: FC = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: priceMinSelectedValue,
        options: priceMinOptions
    } = useSelector(minPriceSelector);

    const {
        selectedValue: priceMaxSelectedValue,
        options: priceMaxOptions
    } = useSelector(maxPriceSelector);

    const priceMinInt = parseInt(priceMinSelectedValue || '0', 10);
    const priceMaxInt = parseInt(priceMaxSelectedValue || '0', 10);

    const onMaxPriceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('maxPrice', evt.currentTarget.value));
    };

    const onMinPriceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('minPrice', evt.currentTarget.value));
    };

    const priceOptionLabel = t('filters.field.price.label');
    const maxPriceLabel = t('filters.maxPriceLabelModal');
    const minPriceLabel = t('filters.minPriceLabelModal');

    return (
        <FilterWrapper>
            <DropdownWrapper>
                <LeftWrapper>
                    <StyledDropdownWithLabel
                        id="price_min_mobile"
                        onChange={onMinPriceChange}
                        value={priceMinSelectedValue}
                        name="price_min"
                        aria-label="Min Price"
                        data-testid="min_price_testid_mobile"
                        label={minPriceLabel}
                        hasBorderRadius
                    >
                        {priceMinOptions ? (
                            <ForSalePriceMinSelectOptions
                                options={priceMinOptions}
                                priceOtherInt={priceMaxInt}
                                keyPrefix="modal-pricemin"
                            />
                        ) : (
                            <option key="modal-price_min">
                                {priceOptionLabel}
                            </option>
                        )}
                    </StyledDropdownWithLabel>
                </LeftWrapper>
                <RightWrapper>
                    <StyledDropdownWithLabel
                        id="price_max_mobile"
                        onChange={onMaxPriceChange}
                        value={priceMaxSelectedValue}
                        name="price_max"
                        aria-label="Max Price"
                        data-testid="max_price_testid_mobile"
                        label={maxPriceLabel}
                        hasBorderRadius
                    >
                        {priceMaxOptions ? (
                            <ForSalePriceMaxSelectOptions
                                options={priceMaxOptions}
                                priceOtherInt={priceMinInt}
                                keyPrefix="modal-pricemax"
                            />
                        ) : (
                            <option key="modal-price_max">
                                {priceOptionLabel}
                            </option>
                        )}
                    </StyledDropdownWithLabel>
                </RightWrapper>
            </DropdownWrapper>
        </FilterWrapper>
    );
};
